// 261010 Epic 2 / P2b-3 — một dòng thoại, trích NGUYÊN VĂN từ EventPlanTab.tsx (move-only) để dùng chung với khung mới. Kèm `DMODE_OPTS` (chỉ dòng thoại dùng).
import React from 'react';
import { Button, Popconfirm, Select, Space, Tag, Tooltip, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import type { FilmDialogueLine, FilmDialogueMode } from '../../types/film';

const { Text } = Typography;

const DMODE_OPTS: { label: string; value: FilmDialogueMode; title?: string }[] = [
  { label: 'ON', value: 'ON_CAMERA', title: 'On-camera — speaks in frame' }, { label: 'OFF', value: 'OFF_CAMERA', title: 'Off-camera — speaks off frame' },
  { label: 'V.O.', value: 'NARRATOR', title: 'Voice-over — narration' }, { label: 'none', value: 'NONE', title: 'No dialogue' },
];

// 1 câu thoại. Speaker = Select (chọn từ cast) → click option ăn ngay, không race blur như AutoComplete.
export const DialogueRow: React.FC<{
  d: FilmDialogueLine; castOpts: { label: string; value: string }[]; simple?: boolean;
  /** shot đang mang câu này (undefined = chưa gán shot nào — prompt sẽ phải tự đoán). */
  shotOrder?: number;
  onMode: (v: FilmDialogueMode) => void; onSpeaker: (v: string) => void; onText: (v: string) => void; onDelete: () => void;
}> = ({ d, castOpts, simple, shotOrder, onMode, onSpeaker, onText, onDelete }) => (
  <Space size={4} style={{ display: 'flex', marginBottom: 2 }} align="center">
    {!simple && (
      <Tooltip title="Dialogue mode: ON = on-camera · OFF = off-camera · V.O. = voice-over · none = no line">
        <Select size="small" value={d.dialogueMode} options={DMODE_OPTS} style={{ width: 74 }} onChange={onMode} />
      </Tooltip>
    )}
    <Tooltip title="Speaker (pick from cast, type to filter)">
      <Select size="small" showSearch allowClear placeholder="speaker" value={d.speakerName || undefined}
        options={castOpts} style={{ width: 124 }} onChange={(v) => onSpeaker(v || '')} />
    </Tooltip>
    {!simple && (shotOrder
      ? <Tooltip title="Câu này được nói ở shot đó"><Tag color="green" style={{ margin: 0 }}>🗣 shot #{shotOrder}</Tag></Tooltip>
      : <Tooltip title='Chưa gán vào shot nào — chọn ở ô "🗣 line" của shot bên dưới. Không gán thì prompt tự đoán câu nào nói ở khung nào, và giây per-shot bị rải đều.'><Tag color="orange" style={{ margin: 0 }}>chưa gán shot</Tag></Tooltip>)}
    {(d as any).origin === 'AI_ADDED' && (
      <Tooltip title="Lời dẫn do AI viết (V.O.-fill, dạng II) — duyệt: sửa/xoá thoải mái, giữ nguyên là chấp nhận">
        <Tag color="purple" style={{ margin: 0 }}>AI</Tag>
      </Tooltip>
    )}
    <Text italic style={{ fontSize: 11, flex: 1 }} editable={{ text: d.textEn ?? '', onChange: onText, tooltip: 'Edit line (English)' }}>"{d.textEn || ''}"</Text>
    <Popconfirm title="Delete this line?" okText="Delete" cancelText="Cancel" okButtonProps={{ danger: true }} onConfirm={onDelete}>
      <Tooltip title="Delete line"><Button type="text" size="small" danger icon={<DeleteOutlined />} /></Tooltip>
    </Popconfirm>
  </Space>
);

export default DialogueRow;
